import { render } from "./PageSchoolOrder.vue?vue&type=template&id=4cc8b1e1&scoped=true"
import script from "./PageSchoolOrder.vue?vue&type=script&lang=js"
export * from "./PageSchoolOrder.vue?vue&type=script&lang=js"

import "./PageSchoolOrder.vue?vue&type=style&index=0&id=4cc8b1e1&scoped=true&lang=css"

import exportComponent from "/var/www/vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4cc8b1e1"]])

export default __exports__